import { useAuth } from "@/App"
import { BidFormSchema } from "./Interface/DefaultSchema"
import { EmployeeProps } from "@/interfaces/employee_type"
import { BidProps } from "@/interfaces/bid_types"
import { zodResolver } from "@hookform/resolvers/zod"
import { z } from "zod"
import { useForm } from "react-hook-form"
import { ImportFormProps } from "./Interface/ImportForm"
import { DefaultProps } from "./Interface/DefaultProps"
import { BidFormBase } from "./BidFormBase"
import { useFormData } from "@/components/_Shared/Form/Hooks/useFormDataFetch"
import { useEffect } from "react"
import { Error_Component, MethodHandler } from "@/components/misc"
import { Alert } from "@/components/_Shared/Form/Buttons/Alert"
import { formatBidData } from "./Utils/formatBidData"
import { createBid, updateBid } from "../api/bids"

export function BidForm(
    {formProps, method}: {formProps?: BidProps, method: "POST" | "PUT"}
) {
    const { user } = useAuth()
    const { projectManagers, cities, fetchAllDataProject } = useFormData()

    const { 
        register, 
        handleSubmit, 
        formState: { errors, isSubmitting, isSubmitSuccessful },
        control,
        setError,
    } = useForm<z.infer<typeof BidFormSchema>>({
        resolver: zodResolver(BidFormSchema),
        defaultValues: formProps ? ImportFormProps({formProps}) : DefaultProps({user: user as EmployeeProps})
    })

    const onSubmit = async (data: z.infer<typeof BidFormSchema>) => {
        const bid_data = formatBidData(data, formProps?.bid_id)
        const method_handler = MethodHandler(method, createBid, updateBid)

        if (method_handler) {
            const response = await method_handler(bid_data)

            if (response.operation === "ERROR") {
                setError("root", {message: "An error occurred while submitting the bid form."})
            } 
        } else {
            console.error("Method handler not found")
            setError("root", {message: "An error occurred while submitting the bid form."})
        }
    }

    useEffect(() => {
        fetchAllDataProject()
    }, [fetchAllDataProject])

    return (
        <>
        {isSubmitSuccessful && 
            <Alert
                title="Success"
                description={`The bid has been ${method === "POST" ? "created" : "updated"} successfully.`} 
                redirects={
                    [
                        {label: "To Bids", value: "/bids"},
                        {label: "To Dashboard", value: "/main_menu"}
                ]
                } />}

        {errors.root && <Error_Component errorString={errors.root.message || "An error occurred"} />}

        <BidFormBase register={register} control={control} manager_list={projectManagers} city_list={cities} onSubmit={handleSubmit(onSubmit)} method={method} errors={errors} isProcessing={isSubmitting} bid_id={formProps?.bid_id ?? ""} />
        </>
    )
}